export default [
  { id: 1, name: "Mo", value: "Monday", letter: "M" },
  { id: 2, name: "Tu", value: "Tuesday", letter: "T" },
  { id: 3, name: "We", value: "Wednesday", letter: "W" },
  { id: 4, name: "Th", value: "Thursday", letter: "T" },
  { id: 5, name: "Fr", value: "Friday", letter: "F" },
  { id: 6, name: "Sa", value: "Saturday", letter: "S" },
  { id: 7, name: "Su", value: "Sunday", letter: "S" },
]
